<template>
    <div class="bg-info text-white py-3 px-4 z-index-3 position-relative">
        <div class="d-flex align-items-center">
            <i class="fa fa-envelope mr-1"></i>
            {{
                translate('Please verify your email address to get another %pendingCredits% Credits. Your account is limited without verifying your email address.'
                    ,{ '%pendingCredits%': this.pendingCredits })
            }}
            <button class="ml-3 btn btn-outline-light" v-on:click="showResend = !showResend">
                {{ translate('Fix now') }}
            </button>
        </div>

        <div v-if="showResend" class="mt-4">
            <div class="mt-2" v-html="emailText"></div>
            <div>{{ translate('Click the confirmation link in your email.') }}</div>
            <div class="mt-3">
                <button :disabled="disableResend" class="btn btn-light mr-3" v-on:click="resendConfirmation">
                    <i class="fa fa-envelope mr-1"></i>
                    {{ translate('Resend confirmation email') }}
                </button>
                <button class="ml-3 btn btn-outline-light" v-on:click="goToDashboard">
                    <i class="fa fa-edit mr-3"></i>{{ translate('Change email address') }}
                </button>
            </div>
        </div>
        <div v-if="showResendSuccess" class="alert alert-success text-white mt-3" v-html="resentText"></div>
    </div>
</template>

<script>
import TransFilter from '../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { testIsNull } from '../../../lib/test-and-assert/test-base';
import { translate } from '../../../qaamgo/helper/translate';
import { translatePath } from '../../../qaamgo/sat/helper/translate-path';
import { satGlobals } from '../../../qaamgo/sat/helper/sat-globals';
import { pageNotification } from '../../../qaamgo/helper/notify';
import { userManager } from '../user-manager';
import { USER_NOTIFICATIONS } from './user-notifications';
import { User } from '../user';

export default {
    name: USER_NOTIFICATIONS.UNCONFIRMED_USER,
    mixins: [TransFilter],
    props: {
        data: {
            type: User | null,
            default: null,
        },
    },
    mounted() {
        this.user = this.data;

        this.pendingCredits = this.user?.getAvailableCreditsOnceActive();

        this.email = this.user?.getPlainEmail();
        this.emailText = translate(
            'The registration process is not yet finished. We have sent you a confirmation email to the following e-mail address: <strong>%email%</strong>.',
            { '%email%': this.email }
        );
        this.resentText = translate('A confirmation email was sent to <strong>%1</strong>', { '%1': this.email });
    },
    methods: {
        async resendConfirmation() {
            this.disableResend = true;

            try {
                await userManager.resendConfirmationMail(this.storeUser.getEmail());

                this.showResendSuccess = true;
            } catch (e) {
                pageNotification.showGenericErrorMessage();
            }

            // allow resending after 5s
            setTimeout(() => {
                this.disableResend = false;
            }, 5000);
        },
        goToDashboard() {
            window.allowLeave = true;
            window.location = satGlobals.getAccountUrl() + translatePath('/user/change-email');
        },
    },
    data() {
        return {
            user: null,
            showResend: false,
            disableResend: false,
            showResendSuccess: false,
            pendingCredits: 0,
            email: '',
            emailText: '',
            resentText: '',
        };
    },
};
</script>
